import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import image from "../../assets/switching/professional/pro-max-24.png";
import type { Product } from "../../types";
import { productListSwitchingProfessional } from "../product-list-groups/productListSwitchingProfessional";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const professionalMax24: Product = {
  id: "professionalMax24",
  productTitle: "Pro Max 24",
  description: "professionalMax24.description",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-pro-max-24"],
  storePathParts: {
    productSlug: "usw-pro-max-24",
    category: UniFiChildCategorySlug.SwitchingProfessionalMaxXg,
  },
  sku: "USW-Pro-Max-24",
  image: { src: image, width: 200, height: 140 },
  productListGroup: productListSwitchingProfessional,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442 x 325 x 44 mm\n(17.4 x 12.8 x 1.7")',
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "24 + 2 SFP+" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: {
        type: "translation",
        value: "commons.speed.upTo2_5Gbps",
      },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "10 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "generalRedundancy",
      value: {
        type: "translation",
        value: "commons.powerRedundancy.unifiPowerBackupReady",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer3",
      },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: true },
    },

    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
  ],
};
